import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import type { DataCreditsStateDto } from '../../domain/quota';
import { queryClient } from '../../queryClient';

import quotaApi from './api';
import { useIsDataCreditsEnabled } from './hooks/useIsDataCreditsEnabled';
import quotaQueryKeys from './queryKeys';

export const useDataCreditsQuery = <TData = DataCreditsStateDto>(options?: {
  select?: (data: DataCreditsStateDto) => TData;
}) => {
  const { isOpen } = useAppState();

  const { isDataCreditsEnabled } = useIsDataCreditsEnabled();

  return useQuery({
    enabled: isOpen && isDataCreditsEnabled,
    queryKey: quotaQueryKeys.dataCredits(),
    queryFn: quotaApi.getDataCredits,
    select: options?.select,
  });
};

export const invalidateDataCreditsQuery = () => {
  queryClient
    .invalidateQueries({
      queryKey: quotaQueryKeys.dataCredits(),
    })
    .catch(console.error);
};
